module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('div', {
    slot: "header"
  }, [_c('v-sub-header', [_c('template', {
    slot: "header"
  }, [_c('router-link', {
    staticClass: "ltc-tufts-blue",
    attrs: {
      "to": {
        name: 'projects.index'
      }
    }
  }, [_vm._v("\n          Projektit\n        ")]), _vm._v("\n        / " + _vm._s(_vm.$store.state.project.current.projectName) + "\n      ")], 1), _vm._v(" "), _c('template', {
    slot: "right-col"
  }, [_c('button', {
    staticClass: "btn btn-midnight-blue pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isCategoryModalShown = true
      }
    }
  }, [_c('span', {
    staticClass: "ion ion-plus-circled icon-spacer icon-anti-flash-white"
  }), _vm._v("\n            Uusi tarjouspyyntö projektiin\n      ")])])], 2)], 1), _vm._v(" "), _c('v-bloc', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#open-quotes",
      "data-toggle": "pill",
      "role": "tab"
    }
  }, [_vm._v("Avoimet tarjouspyynnöt")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#accepted-suppliers",
      "data-toggle": "pill",
      "role": "tab"
    }
  }, [_vm._v("Hyväksytyt toimittajat")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Hae"
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.doFilter($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "open-quotes",
      "role": "tabpanel"
    }
  }, [_c('v-vuetable-container', [_c('vuetable', {
    ref: "quoteRequestsTable",
    staticClass: "mg-md",
    attrs: {
      "css": _vm.css,
      "api-url": _vm.url + '/quotes?projectId=' + _vm.$store.state.route.params.projectId,
      "fields": _vm.fields,
      "query-params": {
        sort: '$sort',
        page: '',
        perPage: '$limit'
      },
      "pagination-path": "",
      "append-params": _vm.moreParams,
      "no-data-template": _vm.noDataTemplate(this.loading, 'Ei vielä lähetettyjä tarjouspyyntöjä.')
    },
    on: {
      "vuetable:loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "quoteName",
      fn: function(props) {
        return [_c('router-link', {
          staticClass: "ltc-tufts-blue bold-link",
          attrs: {
            "to": _vm.formLinkToQuote(props.rowData, 'bidders.index')
          }
        }, [_vm._v("\n                " + _vm._s(_vm.formatQuoteName(props.rowData.quoteName)) + "\n              ")])]
      }
    }, {
      key: "actions",
      fn: function(props) {
        return [_c('div', {
          staticClass: "custom-actions"
        }, [_c('router-link', {
          staticClass: "btn btn-sm inverse-color pull-right",
          attrs: {
            "to": _vm.formLinkToQuote(props.rowData, 'received-offers.index')
          }
        }, [_c('span', {
          staticClass: "ion ion-eye icon-spacer icon-midnight-blue"
        }), _vm._v(" Näytä tarjoukset\n                ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm inverse-color pull-right",
          on: {
            "click": function($event) {
              _vm.isRemoveModalShown = true, _vm.setSelectedRow(props.rowData.id)
            }
          }
        }, [_c('span', {
          staticClass: "ion ion-trash-a icon-spacer icon-midnight-blue"
        }), _vm._v(" Poista\n                ")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "vuetable-pagination ui basic segment grid"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('v-spinner') : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "accepted-suppliers",
      "role": "tabpanel"
    }
  }, [_c('v-vuetable-container', [_c('v-selected-suppliers-vuetable'), _vm._v(" "), _c('div', {
    staticClass: "vuetable-pagination ui basic segment grid"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('v-spinner') : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('v-modal', {
    attrs: {
      "modalShow": _vm.showCategoryModal(),
      "modalHeader": "Lisää kategoria",
      "modalConfirm": "Jatka"
    },
    on: {
      "close": function($event) {
        _vm.isCategoryModalShown = false
      },
      "submit": function($event) {
        _vm.createQuote()
      }
    }
  }, _vm._l((this.$store.state.category.all), function(category) {
    return _c('div', {
      staticClass: "btn-group",
      slot: "modalContent"
    }, [_c('v-button', {
      attrs: {
        "item": category.serviceCategoryName,
        "value": category.id
      }
    })], 1)
  })), _vm._v(" "), _c('v-modal', {
    attrs: {
      "modalShow": _vm.showRemoveModal(),
      "modalHeader": "Haluatko varmasti poistaa tarjouspyynnön?"
    },
    on: {
      "close": function($event) {
        _vm.isRemoveModalShown = false
      },
      "submit": function($event) {
        _vm.removeQuoteRequest(_vm.selectedRow)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-42aceebb"}!./src/app/pages/bids-open/bids-open.html
// module id = 473
// module chunks = 1